module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAPCAYAAAAs9AWDAAAABGdBTUEAALGPC/xhBQAAADZJREFUGBljnD59+n8GNMCExgdzWYBkIzYJ4sQYibYIq+3ECxLnHJAqkJMa0JWDvFmPLojVdgDQ7wjlQp1HDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/dashed.png
// module id = ./assets/dashed.png
// module chunks = 170844033123148